import { render, staticRenderFns } from "./Keystroke.vue?vue&type=template&id=3f72965c&"
import script from "./Keystroke.vue?vue&type=script&setup=true&lang=js&"
export * from "./Keystroke.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Keystroke.vue?vue&type=style&index=0&id=3f72965c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports